import request from '@/utils/request';

// Centre de notifications (chantier systeme-notification-generique — Lot 3).
// Endpoints backend scopés à l'utilisateur authentifié.

export function fetchNotifications(params = {}) {
    return request({ url: '/api/notifications', method: 'get', params });
}

export function fetchUnreadCount() {
    return request({ url: '/api/notifications/unread-count', method: 'get' });
}

export function markNotificationRead(id) {
    return request({ url: `/api/notifications/${id}/read`, method: 'post' });
}

export function markNotificationUnread(id) {
    return request({ url: `/api/notifications/${id}/unread`, method: 'post' });
}

// Pastilles du menu latéral, toutes clés en un appel : `{ tickets: 3, projets: 1, … }`.
export function fetchMenuBadges() {
    return request({ url: '/api/menu-badges', method: 'get' });
}

export function markAllNotificationsRead() {
    return request({ url: '/api/notifications/read-all', method: 'post' });
}

export function fetchNotificationPreferences() {
    return request({ url: '/api/notification-preferences', method: 'get' });
}

export function updateNotificationPreference(data) {
    return request({ url: '/api/notification-preferences', method: 'put', data });
}

// Administration du catalogue (Lot 4) — réservé à la permission `manage notifications`.
export function fetchNotificationTypes() {
    return request({ url: '/api/notification-types', method: 'get' });
}

export function updateNotificationType(id, data) {
    return request({ url: `/api/notification-types/${id}`, method: 'put', data });
}
